import { useStoreActions } from "../../../contexts";
import { useMutationState } from "../useMutationState";
export const useRejectServiceDescription = () => {
  const {
    api
  } = useStoreActions();
  const {
    mutateAsync,
    isPending
  } = useMutationState({
    mutationFn: async conversationId => {
      return api.service.rejectServiceDescription(conversationId);
    },
    withPageLoader: false
  });
  return {
    rejectDescription: mutateAsync,
    isLoading: isPending
  };
};